import React from "react";

function SanctionInterStateNOC() {
    return (
        <>
            <div className="relative w-full">
                <p className="openSans-Reg text-sm md:text-lg xl:text-xl grayshade-1">
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy text ever since the 1500s, when an unknown
                    printer took a galley of type and scrambled it to make a
                    type specimen book.
                </p>
            </div>
        </>
    );
}

export default SanctionInterStateNOC;
